import _extends from "@babel/runtime/helpers/esm/extends";
var _Toolbar;
import React from 'react';
import { Toolbar } from '@lumahealthhq/ui-core';
import { AppBarStyled } from '../TODO/ui-core';

/**
 * This is the Fallback component to render till the module is ready.
 */
import { jsx as _jsx } from "react/jsx-runtime";
export default function FallbackAppBarLinks(props) {
  return /*#__PURE__*/_jsx(AppBarStyled, _extends({
    name: "LumaAppBarLinks"
  }, props, {
    children: _Toolbar || (_Toolbar = /*#__PURE__*/_jsx(Toolbar, {}))
  }));
}